// extracted by css-extract-rspack-plugin
export default {"checkBoxWrap":"CardsFieldsSection_checkBoxWrap__c21kW","checkBox":"CardsFieldsSection_checkBox__RSFBZ","disabled":"CardsFieldsSection_disabled__Adtgd"};